export default __webpack_public_path__ + "static/media/mouse-click-wheel.5c84fca3.svg";